module.exports = __webpack_public_path__ + "img/488-78eaea.png";